
import React, { createContext, useContext, useState } from 'react';
// DISABLED: Premium/subscription functionality is turned off. All features are free.
// To re-enable, restore the original logic from version control.
// import { useAuth } from '@/hooks/useAuth';
// import { supabase } from '@/integrations/supabase/client';
// import { useToast } from '@/hooks/use-toast';

interface SubscriptionContextType {
  subscribed: boolean;
  subscriptionTier: string | null;
  subscriptionEnd: string | null;
  loading: boolean;
  checkSubscription: () => Promise<void>;
  createCheckout: (plan: 'monthly' | 'annual') => Promise<void>;
  openCustomerPortal: () => Promise<void>;
  isPremium: boolean;
}

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};

export const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // DISABLED: Hardcoded to make all features free for all users
  // To re-enable premium gating, restore the original useState values and useEffect logic below
  const [subscribed] = useState(true);
  const [subscriptionTier] = useState<string | null>('premium');
  const [subscriptionEnd] = useState<string | null>(null);
  const [loading] = useState(false);

  // DISABLED: No-op functions — Stripe checkout and portal are turned off
  const checkSubscription = async () => {
    // Original logic checked session and called supabase.functions.invoke('check-subscription')
  };

  const createCheckout = async (_plan: 'monthly' | 'annual') => {
    // Original logic created a Stripe checkout session via supabase.functions.invoke('create-checkout')
  };

  const openCustomerPortal = async () => {
    // Original logic opened Stripe customer portal via supabase.functions.invoke('customer-portal')
  };

  const isPremium = true; // DISABLED: Was `subscribed`

  // DISABLED: Original useEffect that checked subscription on session change
  // useEffect(() => {
  //   if (session) {
  //     checkSubscription();
  //   } else if (user === null) {
  //     setSubscribed(false);
  //     setSubscriptionTier(null);
  //     setSubscriptionEnd(null);
  //     setLoading(false);
  //   }
  // }, [user, session]);

  // DISABLED: Original useEffect that auto-refreshed subscription every 30s
  // useEffect(() => {
  //   if (!user) return;
  //   const interval = setInterval(() => { checkSubscription(); }, 30000);
  //   return () => clearInterval(interval);
  // }, [user]);

  return (
    <SubscriptionContext.Provider
      value={{
        subscribed,
        subscriptionTier,
        subscriptionEnd,
        loading,
        checkSubscription,
        createCheckout,
        openCustomerPortal,
        isPremium,
      }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
};
